<script>
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import MessageBoard from '@challenges/components/message-board.vue'
import ProgressGraph from '@challenges/components/progress-graph.vue'
import Team from '@challenges/components/team.vue'

export default {
  components: {
    Layout,
    MessageBoard,
    ProgressGraph,
    Team,
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    competitions() {
      return this.currentUser.competitions
    },
    challengeId() {
      return +this.$route.params.challengeId
    },
    challenge() {
      const { challenge } = this.$route.params
      if (challenge) {
        return challenge
      }
      const curChallenge = this.competitions.find(
        (item) => item.id === this.challengeId
      )
      if (curChallenge && curChallenge.id) {
        return curChallenge
      }
      return {}
    },
  },
  mounted() {
    const { challengeId } = this.$route.params
    if (!challengeId) {
      this.$router.replace({
        name: 'challengesList',
      })
    }
  },
}
</script>

<template>
  <Layout>
    <div>
      <div class="flex border-b border-t border-gray">
        <div class="w-2/5 h-576 overflow-y-auto">
          <MessageBoard
            :challenge-id="challenge.id"
            :messages="challenge.messages"
          />
        </div>
        <div class="w-3/5">
          <ProgressGraph :challenge="challenge" />
        </div>
      </div>
      <div class="flex pr-5">
        <Team
          class="w-1/2"
          :challenge="challenge"
          :group="challenge.groups[0]"
          team-name="Team 1:"
        />
        <Team
          class="w-1/2"
          :challenge="challenge"
          :group="challenge.groups[1]"
          team-name="Team 2:"
        />
      </div>
    </div>
  </Layout>
</template>
